module.exports = __webpack_public_path__ + "media/images/pic/gallery/2018/warsztaty-kawaii-sushi-920b1fde28e3e52a3a8f04c65bd437f2.jpg";